import React, { useEffect, useState } from 'react';
import { IonContent, IonPage, IonButton } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { auth, db } from '../firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import NavBar from './NavBar';

const PaymentSuccess: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [user] = useAuthState(auth);
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const updateSubscription = async () => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          await updateDoc(userRef, {
            subscriptionStatus: 'active',
            hasUnlimitedTokens: true,
            subscriptionStartDate: new Date(),
            // Par défaut, on met la date d'expiration à un an
            subscriptionEndDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000)
          });
        } catch (error) {
          console.error('Error updating subscription status:', error);
        }
      }
      setIsProcessing(false);
    };

    updateSubscription();
  }, [user]);

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center justify-center min-h-screen">
          <div className="text-center p-8 bg-green-50 rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-green-600 mb-4">
              {t('paymentGateway.success')}
            </h1>
            <p className="text-lg text-gray-700 mb-6">
              {t('paymentGateway.successMessage')}
            </p>
            <IonButton
              expand="block"
              onClick={() => history.push('/dashboard')}
              disabled={isProcessing}
            >
              {t('common.continue')}
            </IonButton>
          </div>
        </div>
        <NavBar />
      </IonContent>
    </IonPage>
  );
};

export default PaymentSuccess;
